
import React from "react"
import {Antd, RichText} from 'components'
import * as S from './styles'
import { isDesktop } from '../../utility'

const Modal = Antd.Modal

export default ({modalContent, onCancel}) => {
  return (
    <Modal
      visible={modalContent}
      onCancel={onCancel}
      footer={null}
      width={isDesktop 
          ? (window.innerWidth /2)
          : (typeof window !== "undefined" ?  (window.innerWidth) : 0)}
      height={isDesktop 
          ? (window.innerHeight - 64)
          : (typeof window !== "undefined" ?  (window.innerHeight) : 0)}
      >
      {modalContent && <S.ModalContent>
        <RichText text={`<h1>${modalContent[0]}</h1><p>${modalContent[1]}</p>`} />
      </S.ModalContent>}
    </Modal>
  )
}